import type {
    ButtonGroupMenuItemStyleConstantType
} from "./type";
import {
    getAttachedGroupItemStyle
} from "../../../attachedGroup/stylesheet";

export const getButtonGroupMenuItemStyle = ({
    shapeConfigs,
    isDisabled,
    groupItem,
    isFocused,
    radiuses,
    borders
}: ButtonGroupMenuItemStyleConstantType) => {
    return getAttachedGroupItemStyle({
        outerRadius: groupItem?.outerRadius ?? radiuses.actions,
        innerRadius: groupItem?.innerRadius ?? radiuses.none,
        orientation: groupItem?.orientation ?? "horizontal",
        isOverlap: groupItem?.isOverlap ?? false,
        position: groupItem?.position ?? "only",
        isActive: false,
        shapeConfigs,
        isDisabled,
        isFocused,
        borders
    });
};
